function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { v4 as uuidV4 } from 'uuid';
import store from '../reducers/storeRegistration';
import postWithTokenRefresh from './postWithTokenRefresh';
import { getUser } from './paths';

// Source tag for render crashes caught by ErrorBoundary; the server uses this
// to additionally persist the report to the error cabinet.
export const ERROR_BOUNDARY_SOURCE = 'errorBoundary';
export const buildClientErrorPayload = (error, info, overrides = {}) => {
  const {
    reference = uuidV4().toUpperCase(),
    source
  } = overrides;
  return _objectSpread({
    url: global.location.href,
    userAgent: global.navigator.userAgent,
    name: error === null || error === void 0 ? void 0 : error.name,
    message: error === null || error === void 0 ? void 0 : error.message,
    stack: error === null || error === void 0 ? void 0 : error.stack,
    componentStack: info === null || info === void 0 ? void 0 : info.componentStack,
    time: new Date().toISOString(),
    reference
  }, source ? {
    source
  } : {});
};
export const canReportClientError = () => {
  const user = getUser();
  const {
    customer
  } = store.getState().login || {};
  return Boolean((user === null || user === void 0 ? void 0 : user.access_token) && customer);
};
const logReportFailure = reportError => {
  // Best-effort telemetry must never mask the original render error.
  /* eslint-disable no-console */
  console.error('Failed to report client error:', reportError);
  /* eslint-enable no-console */
};
export const reportClientError = async (error, info, overrides = {}) => {
  if (!canReportClientError()) {
    return;
  }
  const payload = buildClientErrorPayload(error, info, overrides);
  if (!payload.message || !String(payload.message).trim()) {
    return;
  }
  try {
    // A stale access_token (e.g. user idle since last activity) returns 401; the helper
    // refreshes and retries once so we don't silently drop the report.
    await postWithTokenRefresh('/client-errors', payload);
  } catch (reportError) {
    logReportFailure(reportError);
  }
};